<!-- 商品管理 V2 - 商品级采购链接历史弹窗 -->
<template>
  <el-dialog
    :visible.sync="visible"
    width="1040px"
    append-to-body
    custom-class="product-link-history-dialog"
  >
    <div v-loading="loading" class="dialog-content">
      <!-- 当前商品管理番号 -->
      <div class="product-code">
        <span>商品管理番号</span>
        <strong>{{ product.client_sku_code }}</strong>
      </div>
      <!-- 历史采购链接列表 -->
      <div class="link-table">
        <div class="link-grid table-head">
          <div>顺序</div>
          <div>商品链接</div>
          <div>商品图片</div>
          <div>SKU</div>
          <div>工厂</div>
          <div>历史采购订单</div>
        </div>
        <div v-for="(item, index) in list" :key="item.link || index" class="link-grid table-row">
          <div>{{ item.priority == null ? index + 1 : item.priority }}</div>
          <div><a :href="item.link" target="_blank" rel="noopener noreferrer">{{ item.link }}</a></div>
          <div>
            <el-image v-if="item.pic" :src="item.pic" fit="cover" :preview-src-list="[item.pic]" />
          </div>
          <div class="sku-list">{{ item.sku || '-' }}</div>
          <div>{{ item.factory || '-' }}</div>
          <div class="order-list">
            <p v-for="(order, orderIndex) in item.orders" :key="order.order_sn || orderIndex">
              <router-link :to="'/orderDetail?order_sn=' + order.order_sn" target="_blank">{{ order.order_sn }}</router-link>
              <span>{{ order.num }}个</span>
            </p>
          </div>
        </div>
        <div v-if="!loading && !list.length" class="empty">暂无数据</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 商品级采购链接历史
 * 接口：historyPurchaseLinks，展示链接、SKU、关联订单等
 */
export default {
  name: 'ProductLinkHistoryDialog',
  data() {
    return {
      visible: false,
      loading: false,
      product: {}, // 当前列表行商品
      list: [] // 历史链接列表
    }
  },
  methods: {
    // 拉取历史链接并打开弹窗
    async open(product) {
      this.product = product
      this.list = []
      this.visible = true
      this.loading = true
      try {
        const res = await this.$api.productManagementApi.historyPurchaseLinks({
          user_id: product.user_id,
          sys_code: product.sys_code
        })
        this.list = Array.isArray(res.data) ? res.data : ((res.data && res.data.list) || [])
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content { min-height: 180px; }
.product-code { display: flex; align-items: center; gap: 16px; min-height: 42px; margin-bottom: 12px; padding: 0 16px; border-radius: 4px; background: #f5f7fa; }
.product-code span { color: #606266; }
.product-code strong { color: #303133; }
.link-table { overflow: hidden; border: 1px solid #dcdfe6; border-radius: 4px; }
.link-grid { display: grid; grid-template-columns: 110px 1.5fr 120px 150px 1.2fr 1.7fr; }
.link-grid > div { box-sizing: border-box; display: flex; align-items: center; justify-content: center; min-width: 0; padding: 12px; }
.table-head { min-height: 46px; background: #edeff4; font-weight: 700; }
.table-row { min-height: 112px; border-top: 1px solid #dcdfe6; background: #fff; }
.table-row a { color: #0d4fe6; word-break: break-all; }
.table-row .el-image { width: 64px; height: 64px; border-radius: 4px; cursor: zoom-in; }
.sku-list,
.order-list { flex-direction: column; }
.sku-list p,
.order-list p { margin: 2px 0; }
.order-list p { display: flex; gap: 10px; width: 100%; }
.order-list span { white-space: nowrap; }
.empty { padding: 40px; color: #909399; text-align: center; }
</style>

<style lang="scss">
.product-link-history-dialog .el-dialog__body { padding: 12px 20px 24px; }
</style>
